import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { PackageModule } from '../../../shared/components/package/package.module';
import { ProductModule } from "../../../shared/components/product/product.module";

import { SelfAttendanceAutoRechargeChangeComponent } from './auto-recharge-change.component';
import { MatButtonModule } from '@angular/material/button';
import { PackageHelperModule } from 'src/app/shared/components/package-helper/package-helper.module';
import { InfoMessageModule } from 'src/app/shared/components/info-message/info-message.module';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

import { packageSuggestionModalDisplayLogService } from 'src/app/shared/services/packageSuggestionModalDisplayLog.service';
import { OneClickPurchaseModule } from 'src/app/shared/components/one-click-purchase/one-click-purchase.module';
import { ProductConsultaModule } from 'src/app/shared/components/product-consulta/product-consulta.module';


@NgModule({
  imports: [
    CommonModule,
    InfoMessageModule,
    MatDividerModule,
    
    MatCardModule,
    MatIconModule,
    HeroModule,
    PackageModule,
    ProductModule,
    MatButtonModule,
    PackageHelperModule,
    ProductConsultaModule
  ],
  exports: [
    SelfAttendanceAutoRechargeChangeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
  ],
  declarations: [
    SelfAttendanceAutoRechargeChangeComponent
  ]
})

export class SelfAttendanceAutoRechargeChangeModule { }
